import(/* webpackMode: "eager" */ "/app/public/assets/icons/category-10000.png");
import(/* webpackMode: "eager" */ "/app/public/assets/icons/category-11000.png");
import(/* webpackMode: "eager" */ "/app/public/assets/icons/category-12000.png");
import(/* webpackMode: "eager" */ "/app/public/assets/icons/category-13000.png");
import(/* webpackMode: "eager" */ "/app/src/app/(SearchPage)/search/components/SearchPage.tsx");
import(/* webpackMode: "eager" */ "/app/src/context/pageTextContent.tsx")